import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CreditAnalyticsParams } from '../types';
import META from './useTrackCreditWarningPopoverClicked.meta';

export type UseTrackCreditWarningPopoverClickedParams = CreditAnalyticsParams & {
  type: 'popover' | 'banner';
};

export const useTrackCreditWarningPopoverClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreditWarningPopoverClicked = useCallback(
    (params: UseTrackCreditWarningPopoverClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCreditWarningPopoverClicked };
};
